import LegalPage from "@/components/LegalPage";
import { LEGAL_LAST_UPDATED } from "@/data/legal";

const sections = [
  { h: "Our commitment", p: "School Smiles Australia is committed to providing a website that is accessible to the widest possible audience, in line with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA." },
  { h: "Design & development standards", p: "We aim to use semantic HTML, sufficient colour contrast, keyboard-accessible navigation, and descriptive alternative text for meaningful images." },
  { h: "Ongoing improvements", p: "We are actively working to improve accessibility across our website. If you encounter a barrier, please let us know so we can address it." },
  { h: "Contact us", p: "If you need this information in an alternative format, or if you experience any accessibility issues, please contact us via the details on the Contact page." },
];

const Accessibility = () => {
  if (typeof document !== "undefined") document.title = "Accessibility — School Smiles Australia";
  return <LegalPage title="Accessibility Statement" kicker="Legal" sections={sections} lastUpdated={LEGAL_LAST_UPDATED}/>;
};

export default Accessibility;
